import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Grid, TextField } from "@mui/material";
import { useState } from "react";

//Crear componente tipo popup de material UI el cual sera utilizado para confirmar la eliminacion de un registro, debe recibir como props el estado de apertura del popup y la funcion que se ejecutara al confirmar la eliminacion y el mensaje de confirmacion
export const ConfirmTerminar = ({ open, onClose, onConfirm, message }: { open: boolean; onClose: () => void; onConfirm: (cantidad: number | null) => void; message: string; }) => {
    const [error, setError] = useState<string | null>(null);
    const [cantidadS, setCantidadS] = useState<number | null>(null);

    const handleConfirmClick = () => {
        if (cantidadS === null) {
            setError("Debes ingresar una cantidad");
            return;
        }
        setError(null); // limpiar errores
        onConfirm(cantidadS);
    };

    return (
        <Dialog open={open} onClose={onClose}>
            <DialogTitle>Confirmar como terminada</DialogTitle>
            <DialogContent>
                <DialogContentText>{message}</DialogContentText>
                <br />
                <DialogContentText>Si deseas hacerlo entonces escribe la cantidad que se va a descontar</DialogContentText>
                <Grid item marginBottom="15px" marginTop="15px">
                    <TextField label='Cantidad' value={cantidadS} onChange={(e) => {
                        const value = e.target.value;
                        if (/^\d{0,2}$/.test(value)) {
                            setCantidadS(value === '' ? null : Number(value));
                        }
                    }} 
                    error={!!error} helperText={error} inputProps={{ maxLength: 2 }} fullWidth size='small' />
                </Grid>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose} color='inherit' sx={{ color: 'text.secondary' }}>
                    Cancelar
                </Button>
                <Button onClick={handleConfirmClick} variant='contained' color='primary'>
                    Aceptar
                </Button>
            </DialogActions>
        </Dialog>
    );
};